import { motion } from 'framer-motion';
import { Award, Clock, MapPin, TrendingUp, Trophy } from 'lucide-react';

const metrics = [
  { icon: Trophy, value: '50+', label: 'Inventories closed', detail: 'Across mandate-led Indian micro-markets' },
  { icon: Clock, value: '<8', label: 'Months average', detail: 'Compressed launch-to-absorption cycles' },
  { icon: MapPin, value: '8+', label: 'Growth corridors', detail: 'Mumbai, Goa, Nagpur, Vrindavan and beyond' },
  { icon: TrendingUp, value: '3.9X', label: 'Projected Khopoli growth', detail: 'Colliers-rated hotspot projection by 2030' },
];

const Achievements = () => {
  return (
    <section id="achievements" className="bg-[#F5F5F5] py-24 sm:py-32" data-testid="achievements-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-[2rem] bg-[#06101E] text-[#F5F5F5] shadow-[0_35px_100px_rgba(6,16,30,0.24)]">
          <div className="grid lg:grid-cols-[0.88fr_1.12fr]">
            <div className="blueprint-grid-dark relative p-8 sm:p-10 lg:p-12">
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#C5A880]/25 bg-[#C5A880]/10 px-4 py-2 font-tech text-[11px] uppercase tracking-[0.22em] text-[#C5A880]"><Award className="h-4 w-4" /> Performance record</div>
              <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl">Momentum you can measure, not marketing you have to believe.</h2>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-white/60">A young mandate practice with an unusually concentrated record of inventory movement, developer trust, and buyer follow-through.</p>
            </div>
            <div className="grid gap-px bg-white/10 sm:grid-cols-2">
              {metrics.map((metric, index) => {
                const Icon = metric.icon;
                return (
                  <motion.div key={metric.label} initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.55, delay: index * 0.08 }} className="bg-[#06101E] p-7 transition-colors hover:bg-[#0B1F3B]" data-testid={`achievement-metric-${index + 1}`}>
                    <Icon className="mb-10 h-6 w-6 text-[#C5A880]" />
                    <div className="font-display text-4xl font-semibold">{metric.value}</div>
                    <div className="mt-2 font-tech text-[11px] uppercase tracking-[0.2em] text-[#C5A880]">{metric.label}</div>
                    <p className="mt-3 text-sm leading-relaxed text-white/55">{metric.detail}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
